export * from './moveableSceneryTrait';
